import React, {useRef, useState} from 'react';
import {HStack, Icon, Input, Spinner, Flex} from "@chakra-ui/react";
import {IoSend} from "react-icons/io5";
import {PiImageFill} from "react-icons/pi";
import {HiPlusCircle} from "react-icons/hi2";

const ChatInputArea = ({ onSendMessage, isSending, isFullscreen }) => {
    const [newMessage, setNewMessage] = useState('');
    const imageInputRef = useRef(null);
    const attachmentInputRef = useRef(null);

    const handleFileSelect = (event, fileType) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result; 

            const message = {
                type: fileType,
                content: content,
                filename: file.name
            };
            onSendMessage(message);
        };
        reader.readAsDataURL(file);
        event.target.value = null;
    };

    const handleOnAddImage = () => {
        imageInputRef.current.click();
    }

    const handleOnAddAttachment = () => {
        attachmentInputRef.current.click();
    }

    const handleSendMessage = () => {
        if (newMessage && newMessage.length > 0) {
            onSendMessage({type: 'text', text: newMessage});
            setNewMessage('');
        }
    }

    return (
        <HStack w={'full'} justifyContent={'center'}>
            <HStack w={isFullscreen ? '50%' : 'full'} px={4} py={4} gap={3}>
                <input
                    type="file"
                    ref={imageInputRef}
                    style={{display: 'none'}}
                    accept="image/*"
                    onChange={(e) => handleFileSelect(e, 'image')}
                />
                <input
                    type="file"
                    ref={attachmentInputRef}
                    style={{display: 'none'}}
                    accept=".pdf"
                    onChange={(e) => handleFileSelect(e, 'file')}
                />
                <HStack>
                    <Icon fontSize={22} color={isSending ? 'chat.iconDisabled' : 'chat.icon'} cursor={'pointer'}
                          onClick={!isSending ? handleOnAddAttachment : undefined}>
                        <HiPlusCircle/>
                    </Icon>
                    <Icon fontSize={22} color={isSending ? 'chat.iconDisabled' : 'chat.icon'} cursor={'pointer'}
                          onClick={!isSending ? handleOnAddImage : undefined}>
                        <PiImageFill/>
                    </Icon>
                </HStack>
                <Flex flexGrow={1}>
                    <Input borderRadius={'full'} h={8} lineHeight={24} bg={'bg.inputActive'} color={'white'} value={newMessage}
                           onChange={e => setNewMessage(e.target.value)}
                           onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                    />
                </Flex>
                <HStack>
                    <Icon fontSize={22} color={isSending ? 'chat.iconDisabled' : 'chat.icon'} cursor={'pointer'}
                          onClick={!isSending ? handleSendMessage : undefined}>
                        {isSending ? <Spinner size={'md'}/> : <IoSend/>}
                    </Icon>
                </HStack>
            </HStack>
        </HStack>
    );
};

export default ChatInputArea;
